<div class="critical-point-template-page">
  <section class="page-header">
    <div class="header-content">
      <div class="header-text">
        <h1>Kritikus pont sablonok</h1>
        <p>
          Az alábbi sablonokat használhatod új kritikus pontok létrehozásához. Szűrj cím vagy
          leírás alapján, a lista automatikusan frissül.
        </p>
      </div>
      <button
        mat-raised-button
        color="primary"
        (click)="onCreateTemplate()"
        [disabled]="isLoading"
      >
        <mat-icon>add</mat-icon>
        Új sablon
      </button>
    </div>
  </section>

  <div class="filters-container">
    <form class="filter-group" [formGroup]="filterForm">
      <mat-form-field appearance="outline">
        <mat-label>Cím</mat-label>
        <input matInput formControlName="title" placeholder="Keresés cím alapján" />
        <button
          mat-icon-button
          type="button"
          matSuffix
          aria-label="Cím törlése"
          *ngIf="filterForm.get('title')?.value"
          (click)="clearFilter('title')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Leírás</mat-label>
        <input matInput formControlName="description" placeholder="Keresés leírás alapján" />
        <button
          mat-icon-button
          type="button"
          matSuffix
          aria-label="Leírás törlése"
          *ngIf="filterForm.get('description')?.value"
          (click)="clearFilter('description')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </form>

    <form class="sort-group" [formGroup]="sortForm">
      <mat-form-field appearance="outline">
        <mat-label>Rendezés</mat-label>
        <mat-select formControlName="sortOption">
          <mat-option *ngFor="let option of sortOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
  </div>

  <section class="content">
    <ng-container *ngIf="isLoading; else notLoading">
      <div class="state state--loading">
        <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
        <span>Betöltés...</span>
      </div>
    </ng-container>

    <ng-template #notLoading>
      <ng-container *ngIf="!hasError; else errorState">
        <ng-container *ngIf="templates.length > 0; else emptyState">
          <div class="template-grid">
            <mat-card class="template-card" *ngFor="let template of templates">
              <mat-card-header>
                <div class="card-header-content">
                  <div class="title-section">
                    <div class="title-row">
                      <mat-card-title
                        [innerHTML]="(template.autoIncrementId + '. ' + template.title) | highlightText: titleFilter"
                      ></mat-card-title>
                      <span
                        class="status-pill"
                        [ngClass]="template.isGlobal ? 'status-pill--global' : 'status-pill--local'"
                      >
                        {{ template.isGlobal ? "Globális" : "Lokális" }}
                      </span>
                    </div>
                    <mat-card-subtitle>Az elmúlt 30 napban {{ template.usageCount }} alkalommal használták</mat-card-subtitle>
                  </div>
                  <div class="action-buttons">
                    <button
                      mat-icon-button
                      color="primary"
                      (click)="onEditTemplate(template)"
                      [disabled]="isLoading"
                      matTooltip="Sablon szerkesztése"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      color="warn"
                      (click)="onDeleteTemplate(template)"
                      [disabled]="isLoading"
                      matTooltip="Sablon törlése"
                    >
                      <mat-icon>delete</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-card-header>

              <mat-card-content>
                <p class="description" [innerHTML]="template.description | highlightText: descriptionFilter"></p>
              </mat-card-content>

              <mat-card-footer>
                <div class="metadata">
                  <span>Létrehozva: {{ template.createdAt | date: "yyyy. MMM d." }}</span>
                  <span>Frissítve: {{ template.updatedAt | date: "yyyy. MMM d. HH:mm" }}</span>
                </div>
              </mat-card-footer>
            </mat-card>
          </div>
        </ng-container>
      </ng-container>
    </ng-template>

    <ng-template #errorState>
      <div class="state state--error">
        <mat-icon>error_outline</mat-icon>
        <span>A sablonok betöltése nem sikerült. Próbáld meg később.</span>
      </div>
    </ng-template>

    <ng-template #emptyState>
      <div class="state state--empty">
        <mat-icon>inbox</mat-icon>
        <span>Nincs a feltételeknek megfelelő sablon.</span>
      </div>
    </ng-template>
  </section>

  <mat-paginator
    [length]="totalCount"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    showFirstLastButtons
    (page)="onPageChange($event)"
  ></mat-paginator>
</div>

